import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class QualificationTotalsDto {
  @Transform(({ value }) => toEuros(value))
  total: number;
}
